:host {
    display: block;
    top: 0;
    transition: opacity 0.3s ease;
    overflow: auto;
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

:host([active]) {
    position: relative;
    opacity: 1;
    pointer-events: auto;
}
